import { Navigate, useLocation } from 'react-router';

export default function NoMatch() {
  const location = useLocation();
  return <Navigate to="/" replace state={{ from: location }} />;
}
